const yellow = {
  100: "#FEFDEB",
  200: "#FEFBDD",
  300: "#FCF7B6",
  400: "#FDF69B",
  500: "#FCF373",
  600: "#EBD71E",
  700: "#C5AF1B",
  800: "#89771A",
  900: "#544712",
  contrastDefaultColor: "#ffffff"
}

export default yellow
